const state = {
    data: {},
    edited: {},
    editInfoId: null,
    onEdit: {},
    raw: null,
};

const mutations = {
    info_init_raw(state, payload) {
        state.raw = payload;
    },

    info_init(state, payload) {
        state.data = payload;
    },

    info_edited(state, payload) {
        state.edited = payload;
    },

    info_onedit(state, payload) {
        state.editInfoId = payload.id;
        state.onEdit = payload;
    },

    info_clear(state) {
        state.data = {};
        state.edited = {};
        state.editInfoId = null;
        state.onEdit = {};
        state.raw = null;
    },
};

export default { state, mutations };



// WEBPACK FOOTER //
// ./src/modules/ambis_meter/stores/info.js